module.exports = __webpack_public_path__ + "img/failed.10b45d48.svg";